// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"9a5cdd54","123":"d7503b59","220":"e5114cf7","226":"11ae753a","290":"59281422","368":"ba64d3ed","389":"3348908b","430":"f49580aa","431":"7624a11c","640":"90de98f5","703":"f756a3e5","800":"8eb66b1f"}[chunkId] + ".chunk.js";
};